import React, {useState} from 'react';
import * as S from './EditGuest.styles';

import RoomInfoBlock from './RoomInfoBlock/RoomInfoBlock';

const EditGuestBlock = ({roomInfo, updateParams}) => {

  const {roomAmenities = [], roomName, guestDetails} = roomInfo;
  const [guestDetailsArr, setGuestDetails] = useState(guestDetails);

  const addRoom = () => {
    const tempArr = guestDetailsArr.slice();
    tempArr.push({
      adults: '1',
      childs: [],
      removable: true
    });
    setGuestDetails(tempArr);
    updateParams({guestDetails: tempArr});
  }
  
  const removeRoom = (i) => {
    const tempArr = guestDetailsArr.slice();
    tempArr.splice(i, 1);
    setGuestDetails(tempArr);
    updateParams({guestDetails: tempArr});
  }

  const updateGuestInfo = (i, data) => {
    const tempArr = guestDetailsArr.slice();
    if (data) {
      tempArr[i] = {...tempArr[i], ...data};
    }
    setGuestDetails(tempArr);
    updateParams({guestDetails: tempArr});
  }

  return(
    <S.EditGuestMainWrap>
      <S.EditGuestHeadText>Edit guests to view updated cost</S.EditGuestHeadText>
      {(guestDetailsArr.map((guests, i) => <RoomInfoBlock
        key={`room${i}`}
        index={i}
        guests={guests}
        roomName={roomName}
        roomAmenities={roomAmenities}
        updateGuestInfo={updateGuestInfo}
        removeRoom={removeRoom}
      />)) || null}
      <S.AddAnotherRoomWrap>
        <S.AddAnotherText disabled={guestDetailsArr.length >= 8} onClick={addRoom}>+Add Another Room</S.AddAnotherText>
      </S.AddAnotherRoomWrap>
    </S.EditGuestMainWrap>
  );
};

export default EditGuestBlock;